import React, { useState, useEffect, useContext } from "react";
import "../assets/style.css";
import "../assets/css/index.css";
import "../assets/css/grid.css";
import "../assets/css/theme.css";
import batchImg from '../assets/images/challenge-banner.png';
import bannerIcon from '../assets/images/challenge-title.png';
import EditBatchIcon from '../assets/images/edit-batch.png';
import { cx } from '@emotion/css';
import * as styles from './Questions/challanges.style.js';
import "../assets/boxicons-2.0.7/css/boxicons.min.css";

import { Link } from 'react-router-dom'
import ReactDOM from "react-dom";
import NewQuestionBox from "./NewQuestionBox";
import EditImagewithTextfield from "./EditImagewithTextfield";
import EditSpeakTextwithTextfield from "./EditSpeakTextwithTextfield";
import EditQuestionwithRadio from "./EditQuestionwithRadio";
import EditQuestionswithTextfield from "./EditQuestionswithTextfield"
import EditImagewithRadio from "./EditImagewithRadio";
import ImagewithRadio from "./ImagewithRadio";
import CorrectAnswers from "./CorrectAnswers";
import Lottie from 'react-lottie';
import { default as animationData } from '../assets/loader.json'
import Amplify, { Auth } from 'aws-amplify';
import config from '../aws-exports'
import { UserContext } from './UserContext'
import { useLocation } from "react-router";


import { useHistory } from "react-router-dom";


import {
  withAuthenticator
} from "aws-amplify-react"
import Timer from "./Timer"


import { default as animationData1 } from '../assets/congratulations.json'
import { default as animationData2 } from '../assets/tryagain.json'

Amplify.configure(config)
var badWords = require("bad-words")

function EditNewQuestions1(props) {


  const history = useHistory();

  const [user_edit_answers, set_user_edit_answers] = useState({});
  const [user_edit_question, set_user_edit_question] = useState({});
  const [user_edit_imageurl, set_user_edit_imageurl] = useState({});
  const [finallist, set_finallist] = useState([]);

  const [uniqueid, set_uniqueid] = useState(Date.now());



  const [status, setStatus] = useState("Save");
  const [questionBank, set_questionBank] = useState([]);
  const [addnewquestions, set_addnewquestions] = useState(false);
  const [score, set_score] = useState(0);
  const [noofquestionsattended, set_noquestionsattended] = useState(0);
  const [questionnumber, set_questionnumber] = useState(1);
  const [totalquestions, set_totalquestions] = useState(0);
  const [finished, is_finished] = useState(false);
  const [imagewithtextfield, is_imagewithtextfield] = useState(false);
  const [imagewithradio, is_imagewithradio] = useState(false);
  const [questionwithradio, is_questionwithradio] = useState(false);

  const [speakwithtextfield, is_speakwithtextfield] = useState(false);

  const [questionwithtextfield, is_questionwithtextfield] = useState(false);

  const [real_answers, set_real_answers] = useState({});
  const [jwt_token, set_jwt_token] = useState({});
  const [presentquestion, set_presentquestion] = useState({ answers: (4)['Italy', 'Russia', 'USA', 'Germany'], attempts: 0, category: "XX", correctanswer: "XX", failures: 0, id: 0, level: 0, question: "XX", specificcategory: "XX", subcategory: "XX" });
  const { user } = useContext(UserContext);
  // const {user,setUser} = useContext(UserContext);
  let data1 = useLocation();
  // ////console.log("Calling EventsScreen.....")
  // ////console.log(data1.state)
  // const specificcategory = data1.state["specificcategory"]
  // const level1 = data1.state["level"]
  // const limits = data1["limits"]
  // const eventdisplay = data1["eventdisplay"]
  // ////console.log(specificcategory)
  // ////console.log(level1)
  // ////console.log(limits)
  // ////console.log(eventdisplay)
  let answ = []



  function exitpage() {
    history.goBack()

  }


  function playAgainplease() {

    set_score(0)
    set_questionnumber(1)
    set_noquestionsattended(0)
    is_finished(false)
    getToken()
    set_real_answers({})


  }


  const saveQuestionsintoDB = async (jwt, questionslist) => {

    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Authorization': jwt },
      body: JSON.stringify(questionslist)


    };

    //console.log(requestOptions)



    const response = await fetch(`https://api.dev.quizwizard.net/quiz/uploadquestions`, requestOptions)
    // //console.log(response)

    const data = await response.json();
    //console.log(data)
    alert("Questions Successfully Saved")
    setStatus("Save")

  }



  const getToken = async (id, level, category) => {

    Auth.currentSession().then(res => {
      ////console.log(Auth.user.attributes.email)
      let accessToken = res.getAccessToken()
      let jwt = accessToken.getJwtToken()
      set_presentquestion({ answers: (4)['Italy', 'Russia', 'USA', 'Germany'], attempts: 0, category: "XX", correctanswer: "XX", failures: 0, id: 0, level: 3, question: "XX", specificcategory: "XX", subcategory: "XX" })
      getQuestionfromDB(jwt)
      set_jwt_token(jwt)
    })
  };





  const getQuestionfromDB = async (jwt) => {






    // const specificcategory = props.specificcategory
    // const level1 = props.levels
    // const limits = props.limits
    // const eventdisplay = props.eventdisplay



    const specificcategory = data1.state["specificcategory"]
    const level1 = data1.state["levels"]
    //console.log("Levels are ")
    //console.log(level1)
    const limits = data1.state["limits"]
    const eventdisplay = data1.state["eventdisplay"]





    if (eventdisplay == 'ImagewithTextField') {

      is_imagewithtextfield(true)
    }
    else if (eventdisplay == 'SpeakTextwithTextField') {

      is_speakwithtextfield(true)
    }

    else if (eventdisplay == 'ImagewithRadio') {

      is_imagewithradio(true)
    }
    else if (eventdisplay == 'QuestionswithTextField') {

      is_questionwithtextfield(true)
    }

    else {

      is_questionwithradio(true)
    }


    var specificcategoryreplace = ("" + specificcategory).replace(/%20/g, " ");


    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Authorization': jwt },
      // body: JSON.stringify({'question': id , 'tablename': category+"Questions",'level': level})
      body: JSON.stringify({ category: "Mathematics", level: level1, levels: ("" + level1).split(",").map(Number), limits: ("" + limits).split(",").map(Number), name: "Math1", noofretries: 1, points: 5, qualificationno: 9, subcategory: ["Addition"], specificcategory: ("" + specificcategoryreplace).split(","), time: 60, totalquestions: 10 })


    };


    // //////console.log(requestOptions)
    const response = await fetch(`https://api.dev.quizwizard.net/quiz/getquestions`, requestOptions)
    let data = await response.json();
    //console.log("Data is")                
    if (data == null) {
      data = { "message": "Internal server error" }
    }
    if (data["message"] != 'Internal server error') {
      //console.log(data.length)  
      if (data.length <= 0) {
        let id = Date.now()
        for (let i = 0; i < data1.state["limits"][0]; i++) {
          id = id + 1



          data[i] = { question: "", subcategory: data1.state["specificcategory"][0], specificcategory: data1.state["specificcategory"][0], failures: 0, level: data1.state["levels"][0], category: data1.state["category"], id: id, correctanswer: "", answers: ["", "", "", ""] }

        }

      }


      //console.log(totalquestions)
      //console.log(data)
      data.sort((a, b) => (a.id > b.id) ? 1 : -1)

      set_questionBank(data)


      set_presentquestion(data[0])
      let useranswermap = {}

      for (let i = 0; i < data.length; i++) {
        let id = data[i]["id"]
        let level = data[i]["level"]
        let question = data[i]["question"]
        let correctanswer = data[i]["correctanswer"]
        let answers = data[i]["answers"]
        let specificcategory = data[i]["specificcategory"]
        let subcategory = data[i]["subcategory"]
        let category = data[i]["category"]
        let attempts = 0
        let failures = 0







        useranswermap[id] = { level, id, question, correctanswer, answers, attempts, failures, specificcategory, subcategory, category }


      }
      //console.log(useranswermap)
      set_user_edit_answers(useranswermap)
      //console.log(useranswermap[data[0].id].level)


      // useranswermap[id] = {level,id,question,correctanswer,answers,attempts,failures,specificcategory,subcategory,category}
      // //console.log(useranswermap)
      // set_user_edit_answers(useranswermap)  






    }
    else {
      set_addnewquestions(true)
      presentquestion.specificcategory = ""
      presentquestion.answers = []
      presentquestion.correctanswer = ""



    }
    //////console.log(presentquestion) 
    //////console.log(data)

    var questionno
    let dict_answer = real_answers
    for (questionno in data) {



      dict_answer[data[questionno].id] = data[questionno].correctanswer




    }
    set_real_answers(dict_answer)
    ////console.log("Real Answers are ")  
    ////console.log(real_answers)









  };




  function computeAnswer(question, correctanswer, imageurl, id, specificcategory, subcategory, category, level, choices) {

    ////console.log("Question")
    ////console.log(question)
    ////console.log(correctanswer)
    ////console.log(imageurl)
    ////console.log(id)
    ////console.log(specificcategory)
    ////console.log(subcategory)//undefined
    ////console.log(category)
    ////console.log(level)//undefined
    ////console.log(choices)

    let useranswermap = user_edit_answers
    let attempts = 0
    let failures = 0
    subcategory = question
    question = imageurl
    level = data1.state["levels"][0]
    let answers = choices

    ////console.log("Add new Questions")
    ////console.log(addnewquestions)
    if (id == 0 || addnewquestions) {
      id = uniqueid
    }

    useranswermap[id] = { level, id, question, correctanswer, answers, attempts, failures, specificcategory, subcategory, category }






    set_user_edit_answers(useranswermap)




  }


  function computeAnswerRadioBox(question, correctanswer, choices, id) {


    let specificcategory = data1.state["specificcategory"][0]

    let subcategory = data1.state["subcategory"]
    let category = data1.state["category"]
    let level = data1.state["level"]


    //console.log(" AStart ****  computeAnswerRadioBox")
    //console.log(question)
    //console.log(correctanswer)
    //console.log(choices)
    //console.log(specificcategory)
    //console.log(subcategory)
    //console.log(category)
    //console.log(level)
    //console.log(" End ****  computeAnswerRadioBox")
    subcategory = specificcategory
    let useranswermap = user_edit_answers
    let attempts = 0
    let failures = 0
    level = data1.state["levels"][0]
    let answers = choices
    if (id == 0) {
      id = uniqueid
    }

    useranswermap[id] = { level, id, question, correctanswer, answers, attempts, failures, specificcategory, subcategory, category }


    //console.log("Altered map is before setting to the state")     
    //console.log(useranswermap)


    set_user_edit_answers(useranswermap)




  }





  function savechanges() {

    //console.log("Setting Status to Saving")



    // if (filter.isProfane(user_edit_answers[presentquestion.id].question) || filter.isProfane(user_edit_answers[presentquestion.id].correctanswer) || filter.isProfane(user_edit_answers[presentquestion.id].answers[0]) || filter.isProfane(user_edit_answers[presentquestion.id].answers[1]) || filter.isProfane(user_edit_answers[presentquestion.id].answers[2]) || filter.isProfane(user_edit_answers[presentquestion.id].answers[3])) {
    //   alert("Invalid Data.Please correct")

    // }

    let finallist = []
    let count = 0
    let profanewords = 0
    for (const [key, value] of Object.entries(user_edit_answers)) {

      var filter = new badWords();
      finallist[count] = value


      if (filter.isProfane(value.question) || filter.isProfane(value.correctanswer) || filter.isProfane(value.answers[0]) || filter.isProfane(value.answers[1]) || filter.isProfane(value.answers[2]) || filter.isProfane(value.answers[3])) {
        profanewords = 1
        break

      }



      count = count + 1
    }
    ////console.log(finallist)
    if (profanewords == 0) {
      setStatus("Saving ....")
      saveQuestionsintoDB(jwt_token, finallist)
      set_uniqueid(Date.now())
    }
    else {
      alert("Disrespectul words detected. Please correct")
    }



  }


  function addquestions() {

    // console.log("Adding questions")

    let id = Date.now()

    questionBank[totalquestions] = { question: "", subcategory: data1.state["specificcategory"][0], specificcategory: data1.state["specificcategory"][0], failures: 0, level: data1.state["levels"][0], category: data1.state["category"], id: id, correctanswer: "", answers: ["", "", "", ""] }
    //console.log(totalquestions)
    let usermap = user_edit_answers
    usermap[id] = { question: "", subcategory: data1.state["specificcategory"][0], specificcategory: data1.state["specificcategory"][0], failures: 0, level: data1.state["levels"][0], category: data1.state["category"], id: id, correctanswer: "", answers: ["", "", "", ""] }
    set_user_edit_answers(usermap)

    set_questionnumber(totalquestions + 1)
    set_presentquestion(questionBank[totalquestions])

    set_addnewquestions(true)
  }

  function selectedanswers() {


    //console.log(user_edit_answers[presentquestion.id])
    var filter = new badWords();

    // console.log(filter.isProfane(user_edit_answers[presentquestion.id].question))

    // console.log(questionBank[noofquestionsattended + 1]["correctanswer"])
    // console.log(questionBank[noofquestionsattended + 1]["choice1"])
    // console.log(questionBank[noofquestionsattended + 1]["choice2"])
    // console.log(questionBank[noofquestionsattended + 1]["choice3"])
    // console.log(questionBank[noofquestionsattended + 1]["choice4"])

    if (filter.isProfane(user_edit_answers[presentquestion.id].question) || filter.isProfane(user_edit_answers[presentquestion.id].correctanswer) || filter.isProfane(user_edit_answers[presentquestion.id].answers[0]) || filter.isProfane(user_edit_answers[presentquestion.id].answers[1]) || filter.isProfane(user_edit_answers[presentquestion.id].answers[2]) || filter.isProfane(user_edit_answers[presentquestion.id].answers[3])) {
      alert("Disrespectul words detected. Please correct")

    }
    else {
      if (noofquestionsattended + 1 < totalquestions) {
        set_questionnumber(questionnumber + 1)
        set_presentquestion(questionBank[noofquestionsattended + 1])
        set_noquestionsattended(noofquestionsattended + 1)

        ////console.log("Going to next questions")
      }

    }

  }


  function backanswers() {

    // if(answer == real_answers[id]) 
    // {
    //   set_score(score + 1)
    // }

    ////////console.log(user_answers) 
    //noofquestionsattended = noofquestionsattended + 1 
    is_finished(false)
    if (noofquestionsattended > 0) {
      set_questionnumber(questionnumber - 1)
      set_presentquestion(questionBank[noofquestionsattended - 1])
      set_noquestionsattended(noofquestionsattended - 1)
      //////console.log(noofquestionsattended)
    }
    else {
      //Lets update 
      //savechanges()
      //history.goBack()

      // is_finished(true)
      // updateEventyActivity(jwt_token)


    }
    // if(noofquestionsattended + 1  > totalquestions )
    // {
    //   is_finished(true)
    // }

    // set_presentquestion(questionBank[noofquestionsattended])
    //is_finished(true)

  }




  function handleCallback(childData) {
    is_finished(childData)

  }

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice'
    }
  };

  const congratsOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData1,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice'
    }
  };


  const tryagainOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData2,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice'
    }
  };



  useEffect(() => {
    // You need to restrict it at some point
    // This is just dummy code and should be replaced by actual
    let isMounted = true;
    ////console.log("UseEffect calling in QuizApp")   
    getToken();
    //const totalquestions = data1.state["totalquestions"]
    ////console.log(data1.state["levels"])
    // set_totalquestions(props.levels[0])
    set_totalquestions(data1.state["limits"][0])

    return () => { isMounted = false };
  }, []);

  return (



    <div className="">
      <div className={cx(styles.batchBanner)}>
        <img src={batchImg} alt="" />
        <span>
          <img src={bannerIcon} alt="" />
        </span>
      </div>
      <div className={cx(styles.editBatchesMain)}>
        <div className={cx(styles.editBatchIcon)}>
          <img src={EditBatchIcon} alt="" />
        </div>
        {/* Edit images with Text */}
        {finished == false && questionBank.length > 0 && presentquestion.id > 0 && addnewquestions == false && imagewithtextfield ? (<EditImagewithTextfield question={user_edit_answers[presentquestion.id].question} answer={user_edit_answers[presentquestion.id].answers} correctanswer={user_edit_answers[presentquestion.id].correctanswer} id={presentquestion.id} key={presentquestion.id} selectedanswer={(question, answer, imageurl) => computeAnswer(question, answer, imageurl, presentquestion.id, presentquestion.specificcategory, presentquestion.subcategory, presentquestion.category, presentquestion.level, presentquestion.answers)} subcategory={presentquestion.subcategory} questionnumber={questionnumber} level={presentquestion.level} />) : null}
        {finished == false && addnewquestions && imagewithtextfield ? (<EditImagewithTextfield question="" answer="" correctanswer="" id="" key="" selectedanswer={(question, answer, imageurl, choices) => computeAnswer(question, answer, imageurl, presentquestion.id, data1.state["specificcategory"][0], data1.state["subcategory"], data1.state["category"], data1.state["level"], choices)} subcategory="" questionnumber="" />) : null}

        {finished == false && addnewquestions && questionwithtextfield ? (<EditQuestionswithTextfield question="" answer="" correctanswer="" id="" key="" selectedanswer={(question, answer, imageurl, choices) => computeAnswer(question, answer, imageurl, presentquestion.id, data1.state["specificcategory"][0], data1.state["subcategory"], data1.state["category"], data1.state["level"], choices)} subcategory="" questionnumber="" />) : null}

        {/* { finished == false && addnewquestions &&  questionwithradio ?(<EditQuestionwithRadio question="" answer="" correctanswer =  "" id="" key="" selectedanswer={(question,answer,choices) => computeAnswerRadioBox(question,answer,presentquestion.id,data1.state["specificcategory"][0],data1.state["subcategory"],data1.state["category"],data1.state["level"],choices)}  subcategory = "" questionnumber = ""  />):null} */}

        {finished == false && questionBank.length > 0 && presentquestion.id > 0 && Object.keys(user_edit_answers).length > 0 && questionwithradio ? (<EditQuestionwithRadio question={user_edit_answers[presentquestion.id].question} answer={user_edit_answers[presentquestion.id].answers} correctanswer={user_edit_answers[presentquestion.id].correctanswer} id={presentquestion.id} key={presentquestion.id} totalquestions={totalquestions} selectedanswer={(question, answer, choices) => computeAnswerRadioBox(question, answer, choices, presentquestion.id)} subcategory={presentquestion.subcategory} questionnumber={questionnumber} level={presentquestion.level} />) : null}

        {/* { finished ? <div> <div class="questions"> End of Quiz</div> </div>:""}  */}

        {/* {speakwithtextfield  && (questionBank.length >0 || addnewquestions == true ) ? <span className="speak-icon" onClick={props.closeeditquestionswindow}>x</span>: ""} */}


        {questionBank.length > 0 && presentquestion.id > 0 && finished == false && addnewquestions == false && speakwithtextfield ? (<EditSpeakTextwithTextfield question={presentquestion.question} answer={presentquestion.answers} correctanswer={presentquestion.correctanswer} id={presentquestion.id} key={presentquestion.id} selectedanswer={(question, answer, imageurl) => computeAnswer(question, answer, imageurl, presentquestion.id, presentquestion.specificcategory, presentquestion.subcategory, presentquestion.category, presentquestion.level, presentquestion.answers)} subcategory={presentquestion.subcategory} questionnumber={questionnumber} level={presentquestion.level} specificcategory={presentquestion.specificcategory} />) : null}




        {addnewquestions && finished == false && speakwithtextfield ? (<EditSpeakTextwithTextfield question="" answer="" correctanswer="" id="" key="" selectedanswer={(question, answer, imageurl, choices) => computeAnswer(question, answer, imageurl, presentquestion.id, data1.state["specificcategory"][0], data1.state["subcategory"], data1.state["category"], data1.state["level"], choices)} specificcategory="" subcategory="" questionnumber="" />) : null}

        {questionBank.length == 0 && addnewquestions == false ? <Lottie options={defaultOptions} height={400} width={400} /> : ""}

        <div className="dFlexQuestion">
          {finished == false && (questionBank.length > 0 || addnewquestions == true) ? (<button key="Save" className="editBtn" onClick={savechanges} >{status}</button>) : null}

          {finished == false && questionBank.length > 0 && noofquestionsattended > 0 ? (<button key="Back" className="editBtn" onClick={backanswers} >Back</button>) : null}
          {/* { finished == false &&  questionBank.length >0 ? (<button key="Next" className="editBtn" onClick= { selectedanswers } >Next</button>):null }     */}

          {finished == false && questionBank.length > 0 && noofquestionsattended + 1 < totalquestions ? (<button key="Next" className="editBtn" onClick={selectedanswers} >Next</button>) : null}

          {/* {questionBank.length > 0 || addnewquestions == true  ? <button key="Add Questions" className="editBtn" onClick= { addquestions } >Add Questions</button>:""}   */}

          {questionBank.length > 0 || addnewquestions == true ? <button key="Exit" className="editBtn" onClick={exitpage}>Exit</button> : ""}
        </div>

        {/* { finished == false ? (<button key="Save Changes" className="answerBtn" onClick= { savechanges } >Save Changes</button>):null }  
   { <button key="Add Questions" className="answerBtn" onClick= { addquestions } >Add Questions</button>}  

   { addnewquestions == false && finished == false  ? (<button key="Back" className="answerBtn" onClick= { backanswers } >Back</button>):null }     
    { addnewquestions == false && finished == false ? (<button key="Next" className="answerBtn" onClick= { selectedanswers } >Next</button>):null }      */}
      </div>
    </div>

  );
}

export default withAuthenticator(EditNewQuestions1, false);